import { Module } from '@nestjs/common';
import { ServerDataAccessNotificationModule } from '@ip6m/server/data-access-notification';
import { NotificationService } from './services/notification.service';

@Module({
  imports: [ServerDataAccessNotificationModule],
  providers: [NotificationService],
  exports: [NotificationService],
})
export class ServerFeatureNotificationModule {}
